// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* new */

.HomeItem-sliderItemBox-P0fbs {
    position: relative;
    width: 100%;
    max-width: 155px;
    margin: 0 auto;
    text-align: center;
}

.HomeItem-sliderImageBox-aqMjl {
    position: relative;
    width: 100%;
    max-width: 136px;
    height: 136px;
    border-radius: 0 12px 0 12px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    background: var(--category-bg);
    border: 1px solid var(--primary-border);
    margin: 0 auto;
}

.HomeItem-sliderImageBackEffect-KN_no {
    position: absolute;
    top: 3px;
    left: -9px;
    background: var(--primary-gray-bg);
    width: 138px;
    height: 142px;
    border-radius: inherit;
    z-index: -1;
}

.HomeItem-sliderImageBox-aqMjl:hover .HomeItem-sliderImageBackEffect-KN_no {
    background: var(--category-hover);
}

.HomeItem-sliderImageBox-aqMjl>img {
    width: 80px;
    height: 80px;
    -o-object-fit: contain;
       object-fit: contain;
}

.HomeItem-categoryText-GgtHa {
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    color: var(--primary-foreground);
    margin-top: 18px;
}`, "",{"version":3,"sources":["webpack://./src/components/Home/HomeItem/HomeItem.css"],"names":[],"mappings":"AAAA,QAAQ;;AAER;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,4BAA4B;IAC5B,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,8BAA8B;IAC9B,uCAAuC;IACvC,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,kCAAkC;IAClC,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,gBAAgB;AACpB","sourcesContent":["/* new */\n\n.sliderItemBox {\n    position: relative;\n    width: 100%;\n    max-width: 155px;\n    margin: 0 auto;\n    text-align: center;\n}\n\n.sliderImageBox {\n    position: relative;\n    width: 100%;\n    max-width: 136px;\n    height: 136px;\n    border-radius: 0 12px 0 12px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: var(--category-bg);\n    border: 1px solid var(--primary-border);\n    margin: 0 auto;\n}\n\n.sliderImageBackEffect {\n    position: absolute;\n    top: 3px;\n    left: -9px;\n    background: var(--primary-gray-bg);\n    width: 138px;\n    height: 142px;\n    border-radius: inherit;\n    z-index: -1;\n}\n\n.sliderImageBox:hover .sliderImageBackEffect {\n    background: var(--category-hover);\n}\n\n.sliderImageBox>img {\n    width: 80px;\n    height: 80px;\n    object-fit: contain;\n}\n\n.categoryText {\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 28px;\n    color: var(--primary-foreground);\n    margin-top: 18px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sliderItemBox": `HomeItem-sliderItemBox-P0fbs`,
	"sliderImageBox": `HomeItem-sliderImageBox-aqMjl`,
	"sliderImageBackEffect": `HomeItem-sliderImageBackEffect-KN_no`,
	"categoryText": `HomeItem-categoryText-GgtHa`
};
module.exports = ___CSS_LOADER_EXPORT___;
